export default "__VITE_ASSET__VviROhWIdWGBwh5zbtT9rA__";